<template>
  <MapPin
    :google="google"
    :map="map"
    :mapState="mapState"
    :hasIcon="true"
    :hasLabel="!previewMode"
    :position="position"
    @click="$emit('click', $event)">
    <template v-slot:icon>
      <div :class="`marker-taskitem-icon marker-taskitem-status-${taskItem.status}`">
        {{taskItem.sortOrder+1}}
      </div>
    </template>
    <template v-slot:label>
      {{taskItem.name}}
    </template>
  </MapPin>
</template>

<style scoped lang="scss">
$completed-colour: #3EB240;
$waiting-colour: #757997;
$progress-colour: #FF8D3B;

.marker-taskitem-icon {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  line-height: 21px;
  vertical-align: middle;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.marker-taskitem-icon.marker-taskitem-status-pending {
  background-color: $waiting-colour;
}
.marker-taskitem-icon.marker-taskitem-status-active {
  background-color: $progress-colour;
}
.marker-taskitem-icon.marker-taskitem-status-cancelled {
  background-color: $task-item-icon-cancelled;
}
.marker-taskitem-icon.marker-taskitem-status-completed {
  background-color: $completed-colour;
}
</style>

<script>
import MapPin from '@/components/maps/mapPin'

export default {
  name: 'MapTaskItemMarker',
  components: {
    MapPin
  },
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    previewMode: Boolean,
    mapState: Object,
    taskItem: Object
  },
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
}
</script>